'use strict';

// Import module
// import './module/zoom';
import './module/gallery';
// Sass Import
import '../Sass/style.scss';
